import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useDeleteDocumentMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setDisabled, setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const deleteDocument = async (documentId) => {
    const url = encodeURI(`${env.apiUrl}/documents/${documentId}`)
    const response = await securedFetch(url, { method: 'DELETE' })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ documentId }) => deleteDocument(documentId),
    onMutate: () => {
      progressStart()
      setDisabled(true)
    },
    onError: (error) => handleError(error, 'Error deleting document'),
    onSuccess: () => {
      queryClient.invalidateQueries('documents')
      setMessage('Document was deleted')
    },
    onSettled: () => {
      progressEnd()
      setDisabled(false)
    }
  })
}

export { useDeleteDocumentMutation }
